<div *ngIf="params.data && !params.data.editable" class="d-flex" style="flex-direction: row; gap: 5px;">
    <a *ngIf="params.data && !params.data.editable" class="cursorptr" (click)="edit($event)">Edit</a>
</div>

<div class="d-flex" style="flex-direction: column;">
    <a *ngIf="params.data && params.data.editable" class="cursorptr" (click)="update($event)">Update</a>

    <a *ngIf="params.data && params.data.editable" class="cursorptr" (click)="cancel($event)">Cancel</a>
</div>
